<script>
  import ContatoService from '../../../../domain/contato/service/contato'
  import moment from 'moment'
  import { isEmpty } from 'lodash'
  import {mapGetters} from 'vuex'

  export default{
    name: 'email-detail',
    data () {
      return {
        showReply: false,
        mail: {},
        resposta: {
          remetente: '',
          mensagem: ''
        },
        isDeleting: false,
        hasError: false,
        isContesting: false,
        errorMsg: null,
        isLoading: false
      }
    },
    computed: {
      idEmail () {
        return this.$route.params.id
      },
      dataHora () {
        return this.mail.data && moment(this.mail.data.date).format('L LTS')
      },
      isValid () {
        return !isEmpty(this.resposta.remetente) && !isEmpty(this.resposta.mensagem)
      },
      ...mapGetters(['isLogged', 'currentUser'])
    },
    mounted () {
      this.getEmail()
      this.$nextTick(() => {
        this.setLido()
      })
    },
    destroyed () {
      this.mail = {}
      this.hasError = false
    },
    methods: {
      getEmail () { // TODO: Melhorar isso; arrumar uma forma de utilizar os dados vindos do componente pai (problema q é router-link)
        this.isLoading = true
        ContatoService.showEmail(this.idEmail)
          .then(result => {
            this.mail = result.data
            this.isLoading = false
          })
          .catch(error => {
            alert('Ocorreu um erro ao carregar a mensagem. Contate o suporte')
            console.log(error.response.data.errors)
            this.isLoading = false
          })
      },
      deleteEmail () {
        this.isDeleting = true
        ContatoService.deleteEmail(this.idEmail)
          .then(result => {
            // TODO: Colocar mensagem de confirmação
            this.$router.push({ name: 'lista-emails' })
            console.log('excluiu', result.data)
            this.isDeleting = false
          })
          .catch(error => {
            console.log(error.response.data.errors)
            this.isDeleting = false
            this.hasError = true
          })
      },
      excluiResposta () {
        this.resposta = {}
        this.showReply = false
      },
      respondeEmail () {
        this.isContesting = true
        ContatoService.contestEmail(this.mail.id, this.resposta)
          .then(result => {
            console.log(result.data)
            this.isContesting = false
            this.$router.push({ name: 'lista-emails' })
          })
          .catch(error => {
            console.log(error.response.data.errors)
            this.errorMsg = 'Erro ao enviar mensagem'
          })
      },
      setLido () {
        ContatoService.setLido(this.idEmail)
      }
    },
    components: {}
  }
</script>

<template>
  <div>
    <!-- header -->
    <div class="wrapper bg-light lter b-b">
      <router-link :to="{ name: 'lista-emails' }" class="btn btn-sm btn-default w-xxs m-r-sm"><i class="fa fa-long-arrow-left"></i></router-link>
      <div class="btn-group pos-stc m-r-sm">
        <button class="btn btn-sm btn-default w-xxs w-auto-xs" ><i class="fa fa-archive"></i></button>
        <button class="btn btn-sm btn-default w-xxs w-auto-xs" ><i class="fa fa-exclamation-circle"></i></button>
        <button class="btn btn-sm btn-default w-xxs w-auto-xs" @click="deleteEmail()"><i class="fa fa-trash-o"></i></button>
      </div>
      <div class="btn-group pos-stc">
        <div class="btn-group dropdown">
          <button class="btn btn-sm btn-default w-xxs w-auto-xs dropdown-toggle"><i class="fa fa-fw fa-folder"></i> <span class="caret"></span></button>
          <ul class="dropdown-menu">
            <li><a href>Trash</a></li>
            <li><a href>Spam</a></li>
          </ul>
        </div>
        <div class="btn-group dropdown">
          <button class="btn btn-sm btn-default w-xxs w-auto-xs dropdown-toggle"><i class="fa fa-fw fa-tag"></i> <span class="caret"></span></button>
          <ul class="dropdown-menu">
            <li ng-repeat="label in labels">
              <a href>
                <i class="fa fa-fw fa-circle text-muted text-xs"></i>
                Label aqui
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <span class="msg"v-if="isDeleting">Excluindo...</span>
    <span class="msg-error" v-else-if="hasError">Houve um problema ao excluir este e-mail</span>
    <!-- / header -->
    <div class="msg-loading" v-if="isLoading">
      <i class="fa fa-spin fa-spinner"></i> Carregando mensagem, aguarde...
    </div>
    <div v-else>
      <div class="wrapper b-b">
        <h2 class="font-thin m-n">{{ mail.assunto }}</h2>
      </div>
      <div class="wrapper b-b">
        <img  class="img-circle thumb-xs m-r-sm" src="../assets/user-default.png">
        de <a href="javascript:;">{{ mail.email }}</a> em {{ dataHora }}
      </div>
      <div class="wrapper" style="white-space: pre-wrap;">
        {{ mail.mensagem }}
      </div>

      <!--Anexo
      <div class="wrapper">
        <div ng-repeat="attach in mail.attach" class="panel b-a inline m-r-sm m-b-sm bg-light">
          <div class="wrapper-xs b-b"><i class="fa fa-paperclip"></i> {{ attach.name }}</div>
          <div class="wrapper-xs w-sm lt">
            <a ng-href="{{ attach.url }}"><img ng-src="{{ attach.url }}" class="img-full"></a>
          </div>
        </div>
      </div-->
      <div class="wrapper" v-if="!mail.respostas || !mail.respostas.length">
        <div class="panel b-a">
          <div class="panel-heading ng-show">
            <div class="m-b-lg">
              Clique aqui para <a href="javascript:;" class="text-u-l" @click="showReply = !showReply">Responder</a> <!--ou <a href class="text-u-l" @click="showReply = !showReply">Acompanhar</a-->
            </div>
          </div>
          <div class="ng-hide" v-if="showReply">
            <div class="panel-heading b-b b-light">
              {{ resposta.remetente = mail.email }}
            </div>
            <textarea class="wrapper" style="min-height:100px; min-width: 100%; border: none" v-model.trim="resposta.mensagem"></textarea>
            <div class="panel-footer bg-light lt">
              <button class="btn btn-link pull-right" @click="excluiResposta()"><i class="fa fa-trash-o"></i></button>
              <button class="btn btn-info w-xs font-bold" @click="respondeEmail()" :disabled="isContesting || !isValid">{{ isContesting ? 'Enviando...' : 'Enviar' }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-else>
        <div class="panel b-a" v-for="resposta in mail.respostas">
          <div class="panel-heading ng-show">
            <div class="m-b-sm">
              Respondido por {{resposta.usuario.id === currentUser.id ? 'VOCÊ' : resposta.usuario.username.toUpperCase()}} dia {{moment(resposta.data.date).format('L LTS')}}
            </div>
          </div>
          <div class="ng-hide">
            <textarea class="wrapper" style="min-height:100px; min-width: 100%; border: none" v-model="resposta.mensagem" disabled></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .msg {
    background-color: khaki;
    padding: 5px 15px;
    display: block;
    text-align: center;
  }
  .msg-error {
    background-color: tomato;
    padding: 5px 15px;
    display: block;
    text-align: center;
    color: #fff;
    font-weight: bold;
  }
  .msg-loading {
    margin-left: 40%;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// Email.vue?7e8efd0c